import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Product from "./Product";
import Container from "react-bootstrap/Container";

export default function CategoryList({ products }) {
	return (
		<Container fluid>
			<Row>
				{products.map((product) => (
					<Col
						xs={6}
						sm={4}
						md={3}
						lg={3}
						xl={2}
						xxl={2}
						className="mb-3"
						key={product.id}
					>
						<Product {...product} />
					</Col>
				))}
			</Row>
		</Container>
	);
}
